import { useState, useEffect } from "react";
import { COMPANY } from "@/lib/constants";

interface GeoData {
  city: string;
  state: string;
  phone: string;
  phoneFormatted: string;
  phoneHref: string;
}

const STATE_PHONES: Record<string, { phone: string; phoneFormatted: string; phoneHref: string }> = {
  FL: { phone: COMPANY.phone, phoneFormatted: COMPANY.phoneFormatted, phoneHref: COMPANY.phoneHref },
  GA: { phone: COMPANY.gaPhone, phoneFormatted: COMPANY.gaPhoneFormatted, phoneHref: COMPANY.gaPhoneHref },
  TN: { phone: COMPANY.phone, phoneFormatted: COMPANY.phoneFormatted, phoneHref: COMPANY.phoneHref },
  AL: { phone: COMPANY.phone, phoneFormatted: COMPANY.phoneFormatted, phoneHref: COMPANY.phoneHref },
  SC: { phone: COMPANY.phone, phoneFormatted: COMPANY.phoneFormatted, phoneHref: COMPANY.phoneHref },
  NC: { phone: COMPANY.phone, phoneFormatted: COMPANY.phoneFormatted, phoneHref: COMPANY.phoneHref },
};

export const useGeoPersonalization = (): GeoData => {
  const [geo, setGeo] = useState<GeoData>({
    city: "",
    state: "FL",
    ...STATE_PHONES.FL,
  });

  useEffect(() => {
    const saved = localStorage.getItem("obc_geo");
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        const phones = STATE_PHONES[parsed.state] || STATE_PHONES.FL;
        setGeo({ city: parsed.city, state: parsed.state, ...phones });
      } catch {}
      return;
    }

    // Try timezone-based detection as a lightweight alternative to IP lookup
    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      let detectedState = "FL";
      
      if (tz.includes("Chicago") || tz.includes("Indiana")) detectedState = "TN";
      else if (tz.includes("New_York")) detectedState = "FL"; // Could be FL, GA, SC, NC
      
      const phones = STATE_PHONES[detectedState] || STATE_PHONES.FL;
      const data = { city: "", state: detectedState, ...phones };
      setGeo(data);
      localStorage.setItem("obc_geo", JSON.stringify({ city: "", state: detectedState }));
    } catch {}
  }, []);

  return geo;
};
